import angular from 'angular';
import DoctorAdvanceFilterOptionsComponent from './doctor-advance-filter-options.component';

const doctorAdvanceFilterOptions = angular
	.module('doctorAdvanceFilterOptions', [])
	.component('doctorAdvanceFilterOptions', DoctorAdvanceFilterOptionsComponent)
	.name;

export default doctorAdvanceFilterOptions;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-advance-filter-options/doctor-advance-filter-options.module.js